/* ZINGI main product: gallery, pack selector, free-shipping progress, add to cart,
   delivery ETA (cutoff Europe/Bucharest, working days) and mobile sticky ATC bar.
   Plain JS, no dependencies. Works per section root [data-zp]. */
(function () {
  'use strict';

  var TZ = 'Europe/Bucharest';
  var DAY = 86400000;
  // Time-unit strings come from window.ZingiI18n (layout/theme.liquid); the sentence, date locale
  // and transit days (3-5 working days outside Romania) come from the section's ETA config.
  var T = (window.ZingiI18n && window.ZingiI18n.product) || {};
  function fill(tpl, vars, open, close) {
    var str = String(tpl);
    Object.keys(vars).forEach(function (k) { str = str.split(open + k + close).join(vars[k]); });
    return str;
  }

  /* ---------- Delivery ETA ---------- */
  function bucharestWallClock(date) {
    // Returns a Date whose UTC fields equal the Bucharest wall-clock time.
    var parts = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
    }).formatToParts(date).forEach(function (p) { parts[p.type] = p.value; });
    var h = parseInt(parts.hour, 10) % 24;
    return new Date(Date.UTC(+parts.year, +parts.month - 1, +parts.day, h, +parts.minute, +parts.second));
  }

  function isoDay(d) { return d.toISOString().slice(0, 10); }

  function computeEta(cfg) {
    var holidays = (cfg.holidays || []).map(function (s) { return String(s).trim(); }).filter(Boolean);
    function isWorkday(d) {
      var w = d.getUTCDay();
      return w !== 0 && w !== 6 && holidays.indexOf(isoDay(d)) === -1;
    }
    var cutoffH = +cfg.cutoff || 14;
    var transit = +cfg.transit || 2;
    var now = bucharestWallClock(new Date());
    var ship = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
    if (!isWorkday(ship) || now.getTime() >= ship.getTime() + cutoffH * 3600000) {
      do { ship = new Date(ship.getTime() + DAY); } while (!isWorkday(ship));
    }
    var cutoff = ship.getTime() + cutoffH * 3600000;
    var mins = Math.max(1, Math.ceil((cutoff - now.getTime()) / 60000));
    var arrival = ship;
    var n = 0;
    while (n < transit) {
      arrival = new Date(arrival.getTime() + DAY);
      if (isWorkday(arrival)) n++;
    }
    var h = Math.floor(mins / 60);
    var m = mins % 60;
    var time = h > 0
      ? fill(T.timeHm || '[h] h [m] min', { h: h, m: m }, '[', ']')
      : fill(T.timeM || '[m] min', { m: m }, '[', ']');
    var date = arrival.toLocaleDateString(cfg.lang || 'ro-RO', { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' });
    return { time: time, date: date };
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function renderEta(root, cfg) {
    var nodes = root.querySelectorAll('[data-zp-eta]');
    if (!nodes.length) return;
    var eta;
    try { eta = computeEta(cfg); } catch (e) { return; } // keep the fallback text
    var carrier = cfg.carrier ? esc(fill(cfg.carrierTpl || ', cu {carrier}', { carrier: cfg.carrier }, '{', '}')) : '';
    var html = fill(esc(cfg.tpl || 'Comanzi în următoarele {time} → ajunge {date}{carrier}.'), {
      time: '<strong class="zp-eta__time">' + esc(eta.time) + '</strong>',
      date: '<strong class="zp-eta__date">' + esc(eta.date) + '</strong>',
      carrier: carrier
    }, '{', '}');
    nodes.forEach(function (n) { n.innerHTML = html; });
  }

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    var track = root.querySelector('[data-zp-track]');
    if (!track) return;
    var thumbs = root.querySelectorAll('[data-zp-thumb]');
    var dots = root.querySelectorAll('[data-zp-dot]');
    var current = 0;

    function mark(i) {
      if (i === current) return;
      current = i;
      thumbs.forEach(function (t, k) { t.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
      dots.forEach(function (d, k) {
        if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
    }
    function go(i) {
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      mark(i);
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.dataset.zpThumb); }); });
    dots.forEach(function (d) { d.addEventListener('click', function () { go(+d.dataset.zpDot); }); });

    var raf = 0;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        var w = track.clientWidth || 1;
        mark(Math.round(track.scrollLeft / w));
      });
    }, { passive: true });

    track.addEventListener('keydown', function (e) {
      var max = track.children.length - 1;
      if (e.key === 'ArrowRight') { e.preventDefault(); go(Math.min(max, current + 1)); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(Math.max(0, current - 1)); }
    });
  }

  /* ---------- Packs, shipping progress, ATC ---------- */
  function initBuyBox(root) {
    var opts = root.querySelectorAll('[data-zp-opt]');
    var form = root.querySelector('[data-zp-form]');
    if (!form) return;
    var idInput = form.querySelector('[data-zp-id]');
    var qtyInput = form.querySelector('[data-zp-qty]');
    var atc = form.querySelector('[data-zp-atc]');
    var ctaLabel = form.querySelector('[data-zp-cta-label]');
    var error = form.querySelector('[data-zp-error]');
    var ship = root.querySelector('[data-zp-ship]');
    var shipMsg = root.querySelector('[data-zp-ship-msg]');
    var shipMsgM = root.querySelector('[data-zp-ship-msg-m]');
    var dose = root.querySelector('[data-zp-dose]');
    var bar = root.querySelector('[data-zp-bar]');
    var fill = root.querySelector('[data-zp-fill]');
    var sticky = root.querySelector('[data-zp-sticky]');
    var stickyPack = root.querySelector('[data-zp-sticky-pack]');
    var stickyPrice = root.querySelector('[data-zp-sticky-price]');
    var stickyBtn = root.querySelector('[data-zp-sticky-btn]');
    var ds = root.dataset;

    function select(btn) {
      opts.forEach(function (o) { o.setAttribute('aria-pressed', o === btn ? 'true' : 'false'); });
      var d = btn.dataset;
      var free = d.free === 'true';
      var available = d.available !== 'false';
      idInput.value = d.id;
      qtyInput.value = d.qty;
      if (ctaLabel) ctaLabel.textContent = available ? ds.ctaLabel + ' · ' + d.price : ds.soldoutLabel;
      atc.disabled = !available;
      if (stickyBtn) stickyBtn.disabled = !available;
      if (ship) ship.classList.toggle('is-free', free);
      if (shipMsg) shipMsg.textContent = free ? ds.msgFree : ds.msgMore;
      if (shipMsgM) shipMsgM.textContent = free ? ds.msgFree : ds.msgMoreM;
      if (dose) dose.textContent = d.dose || '';
      if (fill) fill.style.width = d.pct + '%';
      if (bar) bar.setAttribute('aria-valuenow', d.pct);
      if (sticky) sticky.classList.toggle('is-free', free);
      if (stickyPack) stickyPack.textContent = d.pack;
      if (stickyPrice) stickyPrice.textContent = d.price;
      if (error) error.textContent = '';
    }
    opts.forEach(function (o) { o.addEventListener('click', function () { select(o); }); });

    form.addEventListener('submit', function (e) {
      var cart = window.ZingiCart;
      if (!cart || typeof cart.add !== 'function') return; // native form post fallback
      e.preventDefault();
      if (atc.getAttribute('aria-busy') === 'true') return;
      atc.setAttribute('aria-busy', 'true');
      if (stickyBtn) stickyBtn.setAttribute('aria-busy', 'true');
      if (error) error.textContent = '';
      Promise.resolve(cart.add([{ id: parseInt(idInput.value, 10), quantity: parseInt(qtyInput.value, 10) || 1 }]))
        .catch(function () { if (error) error.textContent = ds.errorLabel; })
        .then(function () {
          atc.removeAttribute('aria-busy');
          if (stickyBtn) stickyBtn.removeAttribute('aria-busy');
        });
    });

    // Mobile sticky bar (MobileProduct.dc.html) is always visible on mobile and is
    // the only add-to-cart button there; it submits the same form via form="...".
  }

  function init(root) {
    if (!root || root.dataset.zpReady) return;
    root.dataset.zpReady = '1';
    initGallery(root);
    initBuyBox(root);
    var cfg = {};
    var cfgEl = root.querySelector('[data-zp-eta-config]');
    try { cfg = JSON.parse(cfgEl ? cfgEl.textContent : '{}'); } catch (e) { cfg = {}; }
    renderEta(root, cfg);
    setInterval(function () { renderEta(root, cfg); }, 60000);
  }

  function initAll() { document.querySelectorAll('[data-zp]').forEach(init); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector ? e.target.querySelector('[data-zp]') : null;
    if (root) init(root);
  });
})();
